import { z } from 'zod';
import { claimList } from '../../schema/claim.js';
import { shippingClaimList } from '../../schema/shippingClaim/shippingClaim.js';
export const storeCustomer = z.object({
    id: z.number(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    totalOrders: z.number(),
    claims: claimList,
    shippingClaims: shippingClaimList,
});
//# sourceMappingURL=storeCustomer.js.map